import { useMemo } from 'react'
import { SurfaceBackButtonProps } from './SurfaceAvatar.types'

export const defaultBackButton = {} as SurfaceBackButtonProps

export const useBackButton = (
    calculated?: string | boolean,
    previousPathname?: string
) => {
    const backButton = useMemo<SurfaceBackButtonProps | undefined>(() => {
        if (calculated) {
            return {
                to: previousPathname,
                mode: 'calculated',
            }
        }
        return undefined
    }, [calculated, previousPathname])

    return backButton
}
